module.exports = __webpack_public_path__ + "img/slack.0ceca2e9.svg";